module.exports = __webpack_public_path__ + "static/media/Trackall_Logo.f633212b.png";